import * as React from "react";
import PropTypes from "prop-types";
import {Box, Grid, Paper, Stack, useTheme} from "@mui/material";
import Typography from "@mui/material/Typography";
import {blueGrey} from "@mui/material/colors";
import AnnotatorChipsTab from "../chipsTabs/AnnotatorChipsTab";
import {useTranslation} from "react-i18next";

AnnotatorHeader.propTypes = {
    selectedTokens: PropTypes.array,
    usedLabels: PropTypes.array,
    onDelete: PropTypes.func
}

AnnotatorHeader.defaultProps = {
    selectedTokens: [],
    usedLabels: [],
    onDelete: () => null
}

export function AnnotatorHeader({selectedTokens, usedLabels, onDelete}) {
    const theme = useTheme();
    const {t} = useTranslation("common");
    const [displayedLabels, setDisplayedLabels] = React.useState(usedLabels);

    React.useEffect(() => {
        if (selectedTokens.length > 0) {
            let used = new Set();
            selectedTokens.forEach((token) => {
                token.labels.forEach((label) => {
                    used.add(label);
                });
            });
            setDisplayedLabels([...used]);
        } else {
            setDisplayedLabels(usedLabels);
        }
    }, [selectedTokens, usedLabels]);

    const handleDeleteLabel = (labelToDelete) => {
        onDelete(labelToDelete);
    }

    return (
        <Paper elevation={0}>
            <Stack width={"100%"} minHeight="100px">
                <Box flexGrow={1}>
                    {selectedTokens.length > 0
                        ? <Stack direction="row" spacing={1} m={1} alignItems="center">
                            <Typography fontWeight="bold" color="primary.light" minWidth={"fit-content"}>
                                {t("main.components.annotator.header.in")}
                            </Typography>
                            <Grid container spacing={1}>
                                {selectedTokens.map((token) => (
                                    <Grid item key={`selected-token${token.id}`}>
                                        <Typography
                                            fontWeight="bold"
                                            sx={{
                                                bgcolor: theme.palette.mode === "light"
                                                    ? blueGrey[100] : blueGrey[700],
                                                borderRadius: "1em",
                                                padding: theme.spacing(0, 1, 0, 1),
                                                height: "fit-content",
                                                width: "fit-content"
                                            }}>
                                            {token.textContent}
                                        </Typography>
                                    </Grid>
                                ))}
                            </Grid>
                        </Stack>
                        : <Typography fontWeight={"bold"} color={"primary.light"} m={1}>
                            {t("main.components.annotator.header.all")}
                        </Typography>
                    }
                </Box>
                <AnnotatorChipsTab
                    labels={displayedLabels}
                    deletable={selectedTokens.length > 0}
                    onDelete={handleDeleteLabel}/>
            </Stack>
        </Paper>
    );
}
